<div class="bulk-upload-pdf-preview-selector">
  <div class="bulk-upload-pdf-preview-selector__grid">
    <app-new-preview-page-item
      *ngFor="let item of pageItems; index as i; trackBy: trackByIndex"
      [pageNumber]="i + 1"
      [imageUrl]="item.imageUrl"
      [isSelected]="item.isSelected"
      [width]="item.width"
      [height]="item.height"
      (toggleSelection)="toggleItemSelection(i)"
      [style.margin-right.px]="i % 2 === 0 ? 16 : 0"
    >
    </app-new-preview-page-item>
  </div>
</div>
